/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SyncStatusPanel } from './SyncStatusPanel';
// Mock the hook so stories don't make network calls
const mockQueryClient = new QueryClient({
    defaultOptions: { queries: { retry: false } }
});
const healthyCategories = [
    { category: 'payments', lastSuccessAt: '2025-06-10T11:00:00Z', lastErrorAt: null, lastErrorMessage: null },
    { category: 'customers', lastSuccessAt: '2025-06-10T10:30:00Z', lastErrorAt: null, lastErrorMessage: null },
    { category: 'materials', lastSuccessAt: '2025-06-10T10:00:00Z', lastErrorAt: null, lastErrorMessage: null },
    { category: 'tax_rates', lastSuccessAt: '2025-06-09T08:00:00Z', lastErrorAt: null, lastErrorMessage: null },
    { category: 'webhooks', lastSuccessAt: '2025-06-10T14:00:00Z', lastErrorAt: null, lastErrorMessage: null }
];
const errorCategories = [
    { category: 'payments', lastSuccessAt: '2025-06-08T11:00:00Z', lastErrorAt: null, lastErrorMessage: null },
    { category: 'customers', lastSuccessAt: '2025-06-08T10:30:00Z', lastErrorAt: null, lastErrorMessage: null },
    {
        category: 'materials',
        lastSuccessAt: '2025-06-08T10:00:00Z',
        lastErrorAt: '2025-06-10T14:30:00Z',
        lastErrorMessage: 'QuickBooks returned a 401 — token may have expired.'
    },
    { category: 'tax_rates', lastSuccessAt: null, lastErrorAt: null, lastErrorMessage: null },
    { category: 'webhooks', lastSuccessAt: '2025-06-10T09:00:00Z', lastErrorAt: null, lastErrorMessage: null }
];
const qboRows = [
    { category: 'payments', label: 'Payments from QuickBooks', syncable: false },
    { category: 'customers', label: 'Customers & buildings', syncable: true },
    { category: 'materials', label: 'Materials & services', syncable: true },
    { category: 'tax_rates', label: 'Tax rates', syncable: true }
];
const meta = {
    title: 'Features/Settings/Integrations/SyncStatusPanel',
    component: SyncStatusPanel,
    parameters: {
        layout: 'padded'
    },
    decorators: [
        (Story) => (React.createElement(QueryClientProvider, { client: mockQueryClient },
            React.createElement("div", { style: { maxWidth: '640px', margin: '40px auto' } },
                React.createElement(Story, null))))
    ]
};
export default meta;
export const QboHealthy = {
    args: {
        integration: 'qbo',
        title: 'Sync Status',
        subtitle: 'Real-time status of data flowing between Inspect Point and QuickBooks Online.',
        rows: qboRows,
        footerActivityCategory: 'webhooks',
        footerNote: "Status refreshes automatically. Re-syncs run in the background — you'll get a notification when they finish.",
        healthyLabel: 'Healthy'
    },
    parameters: {
        mockData: { integration: 'qbo', categories: healthyCategories }
    }
};
export const QboWithError = {
    args: {
        integration: 'qbo',
        title: 'Sync Status',
        subtitle: 'Real-time status of data flowing between Inspect Point and QuickBooks Online.',
        rows: qboRows,
        footerActivityCategory: 'webhooks',
        footerNote: "Status refreshes automatically. Re-syncs run in the background — you'll get a notification when they finish.",
        healthyLabel: 'Healthy'
    },
    parameters: {
        mockData: { integration: 'qbo', categories: errorCategories }
    }
};
